import {Component, Input, OnChanges} from '@angular/core';

import {Model} from '../../model/model';
import {ObjectList} from '../../model/object-list';

@Component({
  selector: 'app-list-loader',
  templateUrl: './list-loader.component.html',
  styleUrls: ['./list-loader.component.scss']
})
export class ListLoaderComponent implements OnChanges {

  @Input()
  public list: ObjectList<Model> | null;
  visible = false;

  constructor() {
  }

  ngOnChanges() {
    if (this.list !== null) {
      this.list.loadingObservable.subscribe((loading) => this.visible = loading);
    }
  }
}
